import React, { useState } from "react";
import { Box, Button, Typography, TextField } from '@mui/material';

interface OrderFormProps {
  handleOrderSubmit: (productName : string, driverContact : string, driverName : string) => void;
}

const OrderForm: React.FC<OrderFormProps> = ({handleOrderSubmit}) => {
  const [driverContact, setDriverContact] = useState<string>("");
  const [productName, setProductName] = useState<string>("");
  const [driverName, setDriverName] = useState<string>("");
  const [result, setResult] = useState<string>("");
  
    const submitOrder = () => {
        handleOrderSubmit(productName, driverContact, driverName);
        setResult("Created new order");
        setProductName("");
        setDriverContact("");
        setDriverName("");
    };

    const handleProductNameChange = (event:any) => {
        setProductName(event.target.value);
        setResult("");
    };

    const handleDriverContactChange = (event:any) => {
        const value = event.target.value;
        setDriverContact([value.match(/\d+|\+/g)].join('').replace(',', '')); // Only allow numeric input
        setResult("");
    };

    const handleDriverNameChange = (event:any) => {
      setDriverName(event.target.value);
      setResult("");
    };

    const validateInput = () => {
      return productName !== '' && driverContact !== '';
    }

  return (
    <Box>
        <Typography 
          variant="h5" >
            Create a new order
        </Typography>
        <Box className="divider-whitespace"></Box>
        <Box>
            <TextField label="Product name" 
                fullWidth 
                value={productName}
                placeholder="Bananas"
                onChange={handleProductNameChange}>
            </TextField>
        </Box>
        <Box className="divider-whitespace"></Box>
        <Box>
            <TextField label="Driver name" 
                fullWidth 
                value={driverName}
                placeholder="Bob de Boer"
                onChange={handleDriverNameChange}>         
            </TextField>
        </Box>
        <Box className="divider-whitespace"></Box>
        <Box>
            <TextField label="Phone number driver" 
                fullWidth 
                value={driverContact}
                placeholder="+31601234567"
                onChange={handleDriverContactChange}>         
            </TextField>
        </Box>  
        <Box className="divider-whitespace-large"></Box>
        <Button
          variant="contained"
          color="primary"
          onClick={submitOrder}
          fullWidth
          className="popup-button"
          disabled={!validateInput()}
        >
          Create order
        </Button>
        <Box className="divider-whitespace-large"></Box>
        <Typography 
          className="order-message"
          color="blue"
          variant="body2">{result}
        </Typography>
      </Box>
  );
};

export default OrderForm;
